import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import { getAllPermissionKeys } from '@/permissions/all';

type AccessInitialState =
  | {
      authorizedResourceAccess?: AuthorizedResourceAccessMap;
      currentTenantIsAdmin?: boolean;
    }
  | undefined;

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState: AccessInitialState,
): AuthorizedResourceAccessMap {
  const authorizedResourceAccess = initialState?.authorizedResourceAccess || {};

  if (!initialState?.currentTenantIsAdmin) {
    return authorizedResourceAccess;
  }

  return getAllPermissionKeys().reduce<AuthorizedResourceAccessMap>(
    (accumulator, key) => {
      accumulator[key] = true;
      return accumulator;
    },
    {
      ...authorizedResourceAccess,
    },
  );
}
